import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["model", "resolution", "quote"]
  static values = { quotes: Object, defaultResolution: String, duration: Number, estimated: Boolean }

  connect() { this.sync() }

  sync() {
    const prices = this.quotesValue[this.modelTarget.value] || {}
    for (const option of this.resolutionTarget.options) {
      option.disabled = prices[option.value || this.defaultResolutionValue] == null
    }
    const selected = this.resolutionTarget.selectedOptions[0]
    if (selected?.disabled && Object.keys(prices).length) {
      this.resolutionTarget.value = Array.from(this.resolutionTarget.options).find(option => !option.disabled)?.value || ""
    }
    const resolution = this.resolutionTarget.value || this.defaultResolutionValue
    const cost = prices[resolution]
    this.quoteTarget.textContent = cost == null ? "Video generation is unavailable with these settings." :
      `${this.durationValue}s video · ${Math.ceil(Number(cost)).toLocaleString()} ${this.estimatedValue ? "estimated credits" : "credits"}`
  }
}
